export const CartSummary = ({
	totals,
	promoCode,
	promoAmount,
	onPromoChange = null,
	onPromoApply = null,
	promoError = "",
	onCheckout = null,
	setPromoAmount = null,
}) => (
	<div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 space-y-6">
		<h3 className="font-medium text-lg">Order Summary</h3>

		<div className="space-y-3">
			<div className="flex justify-between">
				<span className="text-gray-600">Retail Price</span>
				<span className={totals.discount ? "line-through text-gray-500" : ""}>
					{totals.displayMsrp}
				</span>
			</div>

			{totals.discount && (
				<div className="flex justify-between text-primary">
					<span>
						You Save{" "}
						{totals.discounts.length > 1
							? `${(totals.discounts[0] * 100).toFixed(1)}% + ${(
									totals.discounts[1] * 100
							  ).toFixed(1)}%`
							: `${(totals.discounts[0] * 100).toFixed(1)}%`}
					</span>
					<span>{totals.displaySavings}</span>
				</div>
			)}

			<div className="flex justify-between">
				{/* <span className="text-gray-600">Our Price</span> */}
				<span className="text-gray-600">Subtotal</span>

				<span className="font-medium">{totals.displayOurPrice}</span>
			</div>

			{/* Add Promo Discount Display */}
			{promoAmount > 0 && (
				<div className="flex justify-between text-primary">
					<span>Promo Discount</span>
					<span>
						-
						{totals.country === "USA"
							? `$${promoAmount.toFixed(2)} USD`
							: `$${promoAmount.toFixed(2)} CAD`}
					</span>
				</div>
			)}

			<div className="flex justify-between">
				<span className="text-gray-600">Shipping</span>
				<span className="text-primary font-medium">
					{totals.country === "Canada"
						? "FREE"
						: !totals.shipping
						? "Calculated at Checkout"
						: `$${totals.shipping} USD`}
				</span>
			</div>

			<div className="flex justify-between">
				<span className="text-gray-600">Tax</span>
				<span className="text-primary font-medium">
					{totals.tax === 0
						? "Calculated at Checkout"
						: `$${totals.tax} ${totals.country === "USA" ? "USD" : "CAD"}`}
				</span>
			</div>

			<div className="pt-3 border-t border-gray-200">
				<div className="flex justify-between font-medium">
					<span>Total</span>
					<span>
						${totals.subTotal.toFixed(2)}{" "}
						{totals.country === "USA" ? `USD` : `CAD`}
					</span>
				</div>
			</div>
		</div>
		{onPromoApply && (
			<>
				{!promoAmount && (
					<div className="space-y-3">
						<label className="block text-sm font-medium">Promo Code</label>
						<div className="flex gap-2">
							<input
								aria-label="Promo Code"
								type="text"
								value={promoCode}
								onChange={onPromoChange}
								placeholder="Enter code"
								className={`
                flex-1 px-3 py-2 rounded-xl border focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none
                ${promoError ? "border-red-500" : "border-gray-200"}
              `}
							/>
							<button
								onClick={onPromoApply}
								className="px-4 py-2 bg-primary text-white font-medium rounded-xl hover:bg-primary/90 transition-colors"
							>
								Apply
							</button>
						</div>
						{promoError && <p className="text-red-500 text-sm">{promoError}</p>}
					</div>
				)}
				{promoAmount > 0 && (
					<div className="space-y-2">
						<div className="flex items-center justify-between text-sm">
							<span>
								Code <span className="font-medium">{promoCode}</span> applied
							</span>
							<button
								aria-label="Remove Promo Code"
								onClick={() => {
									onPromoChange({ target: { value: "" } });
									setPromoAmount(0);
								}}
								className="bg-primary text-white rounded-xl px-3 py-2"
							>
								Remove
							</button>
						</div>
					</div>
				)}
			</>
		)}
		{onCheckout && (
			<button
				onClick={onCheckout}
				className="w-full px-6 py-3 bg-primary text-white font-medium rounded-xl hover:bg-primary/90 transition-colors"
			>
				Proceed to Checkout
			</button>
		)}
	</div>
);
